/**
 * App branding configuration.
 * Set NEXT_PUBLIC_APP_NAME in your .env file to customise the displayed name.
 * Defaults to "domin-cx" if the variable is not set.
 *
 * Usage:
 *   import { APP_NAME, APP_NAME_ADMIN } from "@/lib/app-config"
 *
 * Works in both server components (metadata exports, layout files)
 * and client components ("use client"). NEXT_PUBLIC_ prefix ensures
 * the value is inlined at build time and available in all contexts.
 */
export const APP_NAME: string = process.env.NEXT_PUBLIC_APP_NAME ?? "App-FX"
export const APP_NAME_ADMIN: string = `${APP_NAME} Admin`
export const APP_NAME_SUPERADMIN: string = `${APP_NAME} Super Admin`
export const APP_VERSION: string = process.env.NEXT_PUBLIC_APP_VERSION ?? "2.3.6"
